<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useScreenSize } from "../../../utils/useScreenSize";
import NoPermissions from "./NoPermissions.vue";

const { isMobile } = useScreenSize();

interface Props {
  width?: string;
  header?: boolean;
  fullscreen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  width: "24rem",
  fullscreen: true,
});

defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "close"): void;
}>();

const modalRef = ref<HTMLElement | null>(null);
const modalRoot = ref<HTMLElement | null>(null);

// Create modal root element
onMounted(() => {
  modalRoot.value = document.createElement("div");
  modalRoot.value.id = "modal-root";
  document.body.appendChild(modalRoot.value);
});

// Cleanup on unmount
onBeforeUnmount(() => {
  if (modalRoot.value && document.body.contains(modalRoot.value)) {
    document.body.removeChild(modalRoot.value);
  }
});

// Create modal root element
onMounted(() => {
  modalRoot.value = document.createElement("div");
  modalRoot.value.id = "modal-root";
  document.body.appendChild(modalRoot.value);
  document.body.style.overflow = "hidden";
});

// Cleanup on unmount
onBeforeUnmount(() => {
  document.body.style.overflow = "";
  if (modalRoot.value && document.body.contains(modalRoot.value)) {
    document.body.removeChild(modalRoot.value);
  }
});
const noPermission = ref(false); //TODO: Do we need this ??

const modalStyle = computed(() => {
  if (props.fullscreen || isMobile.value == true) {
    return {
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      margin: "0",
      borderRadius: "0",
    };
  }
  return {
    width: props.width,
    maxWidth: "100%",
    maxHeight: "calc(100vh - 40px)", // 20px margin top and bottom
    margin: "20px auto",
  };
});
</script>

<template>
  <Teleport to="body" :disabled="!modalRoot">
    <div
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      :class="{ 'p-0': fullscreen }"
    >
      <div
        ref="modalRef"
        class="bg-white dark:bg-gray-800 shadow-xl flex flex-col"
        :class="[fullscreen ? '' : 'rounded-lg']"
        :style="modalStyle"
      >
        <!-- Fixed Header -->
        <div
          class="flex justify-between bg-white dark:bg-gray-800 px-6"
          :class="[fullscreen ? '' : 'rounded-t-lg']"
        >
        <slot name="header"></slot>
        </div>

        <!-- Scrollable Content -->
        <div class="flex-grow overflow-y-auto p-6">
          <slot name="form"></slot>
          <slot name="footer"></slot>
        </div>
        <NoPermissions
              v-if="noPermission"
              @close="$emit('close')"
              :modal="true"
            />
      </div>
    </div>




  </Teleport>
</template>
